import React from 'react'

export const SinglePageNav = ({ theme, title, onBack }) => {
    let bg = ''
    let bb = '1px solid #bcbcd1'
    if (theme === 'dark') {
        bg = '#19191a'
        bb = '1px solid #0f0f0f'
    }
    return (
        <div className={'App-nav sticky-top p-2 pt-2 text-primary shadow-sm'} style={{ background: bg, borderBottom: bb }}>
            <div className="d-flex justify-content-between">
                <div className="h4 ml-2" style={{ paddingTop: '0.3rem' }}>{title}</div>
                <i className="bi bi-x-lg mr-2" style={{ fontSize: '1.5rem' }} onClick={onBack}></i>
            </div>
        </div>
    )
}

const Nav = ({ theme, title, onBack, menu }) => {
    let bg = ''
    let bb = '1px solid #bcbcd1'
    if (theme === 'dark') {
        bg = '#19191a'
        bb = '1px solid #0f0f0f'
    }
    return (
        <div className={'App-nav sticky-top p-2 pt-2 text-primary shadow-sm'}
            style={{ background: bg, borderBottom: bb }}>
            <div className='d-flex justify-content-between'>
                <div className="d-flex justify-content-start">
                    <i className="bi bi-chevron-left mr-2" style={{ fontSize: '1.5rem' }} onClick={onBack}></i>
                    <div className="h4" style={{ paddingTop: '0.3rem' }}>{title}</div>
                </div>
                {menu && menu(theme)}
            </div>
        </div>
    )
}

export default Nav